export default __webpack_public_path__ + "static/fenistil.checkliste-c18d28fd4951b3948b9220cca41b24a7.jpg";